'use client'

import Image from 'next/image'
import { HTMLProps, useEffect, useRef, useState } from 'react'
import { MdAddCircleOutline } from 'react-icons/md'

const FormUploadImage = ({
    src,
    alt,
    circular,
    name,
    onChange,
    className
}: {
    src?: string
    alt: string
    circular?: boolean
    name?: string
    onChange?: (file: File) => void
    className?: HTMLProps<HTMLElement>['className']
}) => {
    const inputRef = useRef<HTMLInputElement | null>(null)
    const [objectURL, setObjectURL] = useState<string>('')

    useEffect(() => {
        return () => {
            if (objectURL) URL.revokeObjectURL(objectURL)
        }
    }, [objectURL])

    const clickOnHiddenInput = (): void => {
        if (inputRef.current) inputRef.current.click()
    }

    return (
        <div className='w-full flex'>
            <div className={`relative overflow-hidden ${circular ? 'rounded-full' : 'rounded-md'} ${className}`}>
                {(src || objectURL) && (
                    <Image
                        src={objectURL.length > 0 ? objectURL : src || objectURL}
                        fill
                        alt={alt}
                        className='object-cover'
                    />
                )}
                <div
                    className={`absolute top-0 bg-black bg-opacity-50 flex items-center border rounded-full justify-center
                        ${circular ? 'rounded-full' : 'rounded-md'} ${className}`}
                >
                    <MdAddCircleOutline
                        className='w-[20%] h-[20%] text-accent-foreground'
                        onClick={clickOnHiddenInput}
                    />
                </div>
            </div>

            <input
                type='file'
                accept='image/png, image/jpeg'
                hidden
                name={name}
                ref={inputRef}
                onChange={event => {
                    const files = event.target.files
                    if (files) {
                        setObjectURL(URL.createObjectURL(files[0]))
                        if (onChange) {
                            onChange(files[0])
                        }
                    }
                }}
            />
        </div>
    )
}

export default FormUploadImage
